export class Persona{
    
    // "idPersona" : number = 0;
    "ApellidoPaterno" :string;
    "ApellidoMaterno": string;
    "PrimerNombre": string;
    "SegundoNombre": string;
    "Direccion": string;
    "Distrito": string;


}